import { DSL_API_PATH, DSL_BASE_URL } from '../../constants';
import HttpService from '../http-service/http-service';
import ServiceHandler from '../service-handler';

class VehicleImageService {
    public async getVehicleImage(
        vehicleAttributes: { vin: string; year: number },
        angle?: number
    ): Promise<string | null> {
        if (
            vehicleAttributes == undefined ||
            !vehicleAttributes.year ||
            !vehicleAttributes.vin
        ) {
            return null;
        }

        if (!vehicleAttributes.vin || vehicleAttributes.year < 2013)
            return null;
        const {
            current3LetterCountryCode,
        } = ServiceHandler.AppConfigurationService;

        const imageId = Buffer.from(vehicleAttributes?.vin).toString('base64');

        const serviceUrlDefault = `${DSL_BASE_URL +
            DSL_API_PATH.VEHICLE_IMAGE_V2}?imageId=${imageId}&year=${
            vehicleAttributes.year
        }&countryCode=${current3LetterCountryCode.toUpperCase()}`;

        if (angle) {
            const serviceUrlAuth = serviceUrlDefault + `&angle=${angle}`;
            return (await this.imageAvailable(serviceUrlAuth))
                ? serviceUrlAuth
                : (await this.imageAvailable(serviceUrlDefault))
                ? serviceUrlDefault
                : null;
        }

        return serviceUrlDefault;
        /* return (await this.imageAvailable(serviceUrlDefault))
            ? serviceUrlDefault
            : null;*/
    }

    private async imageAvailable(serviceUrl: string): Promise<boolean> {
        try {
            const response = HttpService.get(
                serviceUrl,
                true,
                undefined,
                undefined,
                false
            );
            await response;
        } catch (error) {
            return Promise.resolve(false);
        }
        return Promise.resolve(true);
    }
}
export const vehicleImageService = new VehicleImageService();
